(function () {
  'use strict';

  function normalize(str) {
    return (str || '').trim().toLowerCase();
  }

  function parseData(scriptEl) {
    try {
      var parsed = JSON.parse(scriptEl.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.warn('[cl-lens-type-cards] Failed to parse data:', e);
      return [];
    }
  }

  function findSectionModal(sectionId) {
    return document.querySelector('#cl-lens-modal-' + sectionId);
  }

  /* Find the .tpo_option-type-buttons-wrapper whose radio inputs belong to optionName.
     Easify sets input[name] to "{uuid},{Option Name}" so we split on the last comma. */
  function findOptionWrapper(easifyContainer, optionName) {
    var wrappers = easifyContainer.querySelectorAll('.tpo_option-type-buttons-wrapper');
    for (var i = 0; i < wrappers.length; i++) {
      var input = wrappers[i].querySelector('input.tpo_buttons-input');
      if (!input) continue;
      var parts = input.name.split(',');
      var inputOptionName = parts[parts.length - 1].trim();
      if (normalize(inputOptionName) === normalize(optionName)) {
        return wrappers[i];
      }
    }
    return null;
  }

  function enhanceWrappers(tpoWrapper, data) {
    var wrappers = Array.from(tpoWrapper.querySelectorAll('.tpo_buttons-wrapper'));
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      var input = wrapper.querySelector('input.tpo_buttons-input');
      if (!input) return;

      var optionValue = input.value.trim();
      var matchData = data.find(function (d) {
        return normalize(d.matching_option_title) === normalize(optionValue);
      }) || null;

      if (!matchData) return;

      var label = wrapper.querySelector('label');
      if (!label) return;

      if (matchData.description) {
        var desc = document.createElement('span');
        desc.className = 'cl-ltc-desc';
        desc.textContent = matchData.description;
        label.appendChild(desc);
      }

      if (matchData.badge) {
        var badge = document.createElement('span');
        badge.className = 'cl-ltc-badge';
        badge.textContent = matchData.badge;
        label.appendChild(badge);
      }
    });

    tpoWrapper.classList.add('cl-ltc-enhanced');
  }

  function wireOption(easifyContainer, optionName, data) {
    var wireKey = 'data-cl-ltc-wired-' + normalize(optionName).replace(/\s+/g, '-');

    var tpoWrapper = findOptionWrapper(easifyContainer, optionName);
    if (tpoWrapper && !easifyContainer.hasAttribute(wireKey)) {
      easifyContainer.setAttribute(wireKey, '');
      enhanceWrappers(tpoWrapper, data);
      return;
    }

    var observer = new MutationObserver(function () {
      var tw = findOptionWrapper(easifyContainer, optionName);
      if (!tw) return;
      if (easifyContainer.hasAttribute(wireKey)) return;
      easifyContainer.setAttribute(wireKey, '');
      enhanceWrappers(tw, data);
    });

    observer.observe(easifyContainer, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('[data-cl-ltc-data]').forEach(function (scriptEl) {
      var sectionId = scriptEl.getAttribute('data-cl-ltc-data');
      var optionName = scriptEl.getAttribute('data-cl-ltc-option');
      if (!optionName) return;

      var data = parseData(scriptEl);
      if (!data.length) return;

      var modal = findSectionModal(sectionId);
      if (!modal) return;

      var easifyContainer = modal.querySelector('.easify-product-options');
      if (!easifyContainer) return;

      wireOption(easifyContainer, optionName, data);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
